module.exports = __webpack_public_path__ + "img/logo_with-text.15d713a3.svg";